/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Spaces_EmptyInputs */



/**
* | output |
* | --- |
* | "No space yet, so nobody can call this API. Create a space to store a credential and choose who may use it." |
*
* @param {External_Apis_Spaces_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_spaces_empty = /** @type {((inputs?: External_Apis_Spaces_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Spaces_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch kein Space – niemand kann diese API aufrufen. Legen Sie einen Space an, um Zugangsdaten zu hinterlegen und festzulegen, wer sie nutzen darf.")
	return /** @type {LocalizedString} */ ("No space yet, so nobody can call this API. Create a space to store a credential and choose who may use it.")
});